'use strict';

var HybridDashboardConfig = function HybridDashboardConfig($stateProvider) {
  $stateProvider.state('app.fo-dashboard', {
    url: '/workflow/fo-dashboard',
    ifFeatureEnabled: ['FARES_OPTIMIZER;DASHBOARD'],
    params: {
      transitionData: null
    },
    views: {
      '': {
        template: '<dashboard class="react-pages"> </dashboard>'
      }
    }
  });
};
module.exports = HybridDashboardConfig;
HybridDashboardConfig.$inject = ['$stateProvider'];